import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";
import { Button } from "./ui/button";

export default function UpdateDialog({ updateAvailable }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (updateAvailable) setOpen(true);
  }, [updateAvailable]);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Nová verze k dispozici!</DialogTitle>
          <DialogDescription>
            Je k dispozici nová verze aplikace. Chcete ji nyní jedním kliknutím
            nainstalovat?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => {
              setOpen(false);
            }}
          >
            Zrušit
          </Button>
          <Button
            onClick={() => {
              window.location.reload();
            }}
          >
            Aktualizovat
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
